import React, {useState} from 'react';
import {connect} from 'react-redux';
import Sidebar from '../components/Sidebar';
import HeadLogo from '../assets/images/new_head_logo_type.png';

const Header = (props) => {

    const [expanded, setExpanded] = useState(false);

    const onToggleClicked = (e) => {
        setExpanded(!expanded)
    }

    const onBackPressed = () => {
        props.history.goBack()
    }

    const onHomeClicked = (e) => {
        // window.location.assign('/')
        props.history.push('/')
    }

    const onAddClicked = (e) => {
        props.isAuthenticated 
        ? 
        props.history.push('/register-vehicle',)
        :
        props.history.push('/login',)
    }

    return (
        <div className="header__root">
            {
                !!props.heading ? (
                    <div className="optimized__d-flex-class justify-content-between align-items-center header">
                        <div className='heading-root'>
                            <span onClick={onBackPressed} className="align-middle">
                                <i class="material-icons heading-chevron">chevron_right</i>
                            </span>
                            <span className='heading-text'>{props.heading}</span>
                        </div>
                    </div>
                ) : (
                    <div className="optimized__d-flex-class justify-content-between align-items-center header">
                        <div>
                            <span onClick={onToggleClicked} className="align-middle">
                                <i class="material-icons m-2">menu</i>
                            </span>
                        </div>
                        <img onClick={onHomeClicked} className="head-logo-img" alt="کارکلیک" src={HeadLogo}/>
                        <Sidebar expanded={expanded}/>
                    </div>
                )
            }
            {/* <button className="about__btn--sharp py-3" onClick={onAddClicked}>درج آگهی</button> */}
        </div>
    );
}

const mapStateToProps = (state) => ({
    isAuthenticated: !!state.auth.token
});

export default connect(mapStateToProps)(Header);